<script type="text/jsx" lang="jsx">
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/ZOOM_SCHEDULER/mx/edit-delta';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'SchedulerEditDelta',
  planType: planTypes.ZOOM_SCHEDULER,
  mixin: commonMixin,
});
</script>

<style lang="scss">
.opc-zwb {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
